import { Button, HTMLTable, Intent, NonIdealState, Tag } from "@blueprintjs/core"
import { format } from "date-fns"

import { ApiKey } from "../../../../api/apiKeys"
import { EmptyStateCard, InactiveRow, MutedCell, TableCard } from "./ApiKeys.styled"

interface IApiKeysTableProps {
  apiKeys: ApiKey[]
  onRevoke: (apiKey: ApiKey) => void
  onCreate: () => void
}

const formatDate = (value: string | null) => (value ? format(new Date(value), "dd MMM yyyy") : null)

export const ApiKeysTable = ({ apiKeys, onRevoke, onCreate }: IApiKeysTableProps) => {
  if (apiKeys.length === 0) {
    return (
      <EmptyStateCard>
        <NonIdealState
          icon="key"
          title="No MCP tokens yet"
          description="Create a token to connect an MCP client without a browser login."
          action={<Button icon="add" intent={Intent.PRIMARY} text="New token" onClick={onCreate} />}
        />
      </EmptyStateCard>
    )
  }

  return (
    <TableCard>
      <HTMLTable striped>
        <thead>
          <tr>
            <th>Name</th>
            <th>Created</th>
            <th>Expires</th>
            <th>Last used</th>
            <th>Status</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {apiKeys.map(apiKey => {
            const Row = apiKey.is_active ? "tr" : InactiveRow
            return (
              <Row key={apiKey.id}>
                <td>{apiKey.name}</td>
                <td>{formatDate(apiKey.created_at) ?? <MutedCell>-</MutedCell>}</td>
                <td>{formatDate(apiKey.expires_at) ?? <MutedCell>Never</MutedCell>}</td>
                <td>{formatDate(apiKey.last_used_at) ?? <MutedCell>Never used</MutedCell>}</td>
                <td>
                  <Tag intent={apiKey.is_active ? Intent.SUCCESS : Intent.NONE} minimal>
                    {apiKey.is_active ? "Active" : "Revoked"}
                  </Tag>
                </td>
                <td>
                  {apiKey.is_active && (
                    <Button
                      small
                      minimal
                      intent={Intent.DANGER}
                      text="Revoke"
                      onClick={() => onRevoke(apiKey)}
                    />
                  )}
                </td>
              </Row>
            )
          })}
        </tbody>
      </HTMLTable>
    </TableCard>
  )
}
